import { render, staticRenderFns } from "./ToolPageLayout.vue?vue&type=template&id=04b7eab4&scoped=true"
import script from "./ToolPageLayout.vue?vue&type=script&lang=js"
export * from "./ToolPageLayout.vue?vue&type=script&lang=js"
import style0 from "./ToolPageLayout.vue?vue&type=style&index=0&id=04b7eab4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b7eab4",
  null
  
)

export default component.exports